// Unique suffix to avoid name collision
export const RIGHT_SIDEBAR_WIDTH_CSS_VARIABLE = '--rightSidebarWidth-82jiox721n';

export const setSidebarWidthCssVariable = (width: number) => {
	// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
	document.documentElement.style.setProperty(RIGHT_SIDEBAR_WIDTH_CSS_VARIABLE, `${width}px`);
};
